import './jquery.easing';
import './atd-support';
import './atd-map';
import './atd-modal';
import './atd-responsive-nav';
import './atd-slideshow';
import './atd-smooth-scroll';
import './hero-slider';
import './jquery.inview';
import './jquery.nav';
import './atd-tabs';
import './atd-mobile-app-steps';
import './tooltipster.bundle';
import './did-you-know';
import './atd-start-vimeo';
import './atd-play-vimeo';
import TweenMax from './tweenmax';
import './price-advisor';
import './adaptive-nav';
import './atd-dealer-report';
import './slick';
import './webinar';
import './atd-video-timeline';
import './rotator';
import './inview';

import '../sass/main.scss';


/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;



$(function ($) {

    if ($('.half-circles').length) {
        setInterval(function () {
            $('.half-circles.out').each(function () {
                if ($(this).atdInview()) {
                    $(this).addClass('in').removeClass('out');
                }
            });
        }, 100);
    }
    $('.toggle-additional-fields').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        target.slideToggle(500);
    })

    /* Lead form email redundancy - Josh Kimbrel */
    $('#contact-form').submit(function (e) {
        $.post("contact_form.php", $('#contact-form').serialize());
    });

    $('[data-toggle="target"]').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        var text = $(this).text();
        $(this).text($(this).attr('data-alt-text'));
        $(this).attr('data-alt-text', text);
        target.slideToggle(500);
    });

    /* News pop-up conditionals */
    $('#contact-form').one('inview', function () {
        $('.news-overlay').slideUp(300);
        $('.news-overlay-bg').fadeOut(300);
    });

    //close news popup
    $('.news-close, .news-click-close').click(function (e) {
        e.preventDefault();
        $(this).parent().slideUp(300);
        $('.news-overlay-bg').fadeOut(300);
    });

    $('.news-overlay-bg').click(function (e) {
        e.preventDefault();
        $('.news-overlay').slideUp(300);
        $(this).fadeOut(300);
    })

    if ($('[data-load-video]').length) {
        if ($(document).width() >= 768) {
            $('[data-load-video]').each(function () {
                $(this).attr('src', $(this).attr('data-load-video'));
            });
        }
    }

    //
    $('.btn-jump').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        var offset = target.offset().top - 128;

        $('html, body').animate({
            scrollTop: offset + 'px'
        }, 1000);
    });

    //Blade Nav Listener
    $('.blade-nav-item.hero-toggler').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        var targetBg = $('.cm-primary-hero[data-hero=' + $(this).attr('href') + ']');

        $('.blade-caption').not(target).removeClass('active');
        target.addClass('active');

        $('.cm-primary-hero').not(targetBg).removeClass('active');
        targetBg.addClass('active');

        $('.blade-nav-item').removeClass('active');
        $(this).addClass('active');
    });

    $('.blade-nav-item.content-toggler').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));

        $('.dms-content').not(target).removeClass('active');
        target.addClass('active');

        $('.blade-nav-item').removeClass('active');
        $(this).addClass('active');
        $('.blade-nav-item[href="' + $(this).attr('href') + '"]').addClass('active');

        var offset = target.offset().top - 182;

        $('html, body').animate({
            scrollTop: offset + 'px'
        }, 500);
    });

    $('.out-of-view').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).removeClass('out-of-view');
        }
    });

    $('.parent-out-of-view').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).removeClass('parent-out-of-view').parent().addClass('is-inview');
        }
    });

    //Consumer Media Page: basketball trigger
    $('#basketball-view-trigger').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).closest('.cm-section').addClass('inview');
        } else {
            $(this).closest('.cm-section').removeClass('inview');
        }
    });

    //Consumer Media Page: tv trigger
    $('#tv-view-trigger').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).closest('.cm-section').addClass('inview');
        } else {
            $(this).closest('.cm-section').removeClass('inview');
        }
    });

    //Must Test Drive Page: youtube grid click listener
    //best new cars page
    if ($('.youtube-grid').length) {
        var vidyards = new Vidyard.players();

        $('.youtube-grid a').click(function (e) {
            e.preventDefault();

            var target = $($(this).attr('href'));

            $('.toggle-cars').not(target).removeClass('active');
            target.addClass('active');

            $('.youtube-grid a').not($(this)).removeClass('active');
            $(this).addClass('active');

            if ($('[data-youtube]').length) {
                $('[data-youtube]').each(function () {
                    $(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                });

                target.find('[data-youtube]').get(0).contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }

            if ($('[data-vidyard]').length) {
                $('[data-vidyard]').each(function () {
                    var uuid = $(this).attr('data-vidyard');
                    vidyards[uuid].pause();
                });

                var uuid = target.find('[data-vidyard]').attr('data-vidyard');
                vidyards[uuid].play();
            }

            $('html, body').animate({
                scrollTop: (target.offset().top - 200) + 'px'
            }, 500);
        });

        $('.youtube-grid-hover a').on('mouseover', function () {
            var target = $($(this).attr('href'));

            $('.toggle-cars').not(target).removeClass('active');
            target.addClass('active');

            $('.youtube-grid a').not($(this)).removeClass('active');
            $(this).addClass('active');
        });
    }

    //Consumer Media, Why Autotrader: Sidebar nav interval listener
    setInterval(function () {
        if ($(window).scrollTop() > 0) {
            $('.cm-fixed-nav, .brand-bar').addClass('fixed');
        } else {
            $('.cm-fixed-nav, .brand-bar').removeClass('fixed');
        }
    }, 30);


    $('.brand-bar .brand-btn').click(function (e) {
        e.preventDefault();
        $(this).closest('.brand-bar').toggleClass('active').find('.expanded-bar').slideToggle(400);
    });
    $('.brand-bar .brand-btn').click(function (e) {
        e.preventDefault();
        $(this).closest('.brand-bar').toggleClass('active').find('.expanded-bar').slideToggle(400);

        $('html, body').animate({
            scrollTop: (target.offset().top - 200) + 'px'
        }, 500);
    });

    /* activate tooltipster */
    $('.tooltipster').tooltipster({
        trigger: 'click'
    });

    //Specialty Page: motorcycle-man trigger
    $('#motorcycle-trigger').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).closest('.specialty-section').addClass('inview');
        } else {
            $(this).closest('.specialty-section').removeClass('inview');
        }
    });

    /* isInView */
    $('[data-animate-scroll]').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        var offset = target.offset().top;

        $('html, body').animate({
            scrollTop: offset + 'px'
        }, 1000, 'easeInOutExpo');
    });

    $('#fixed-nav').onePageNav({
        currentClass: 'current',
        scrollSpeed: 1000,
        easing: 'easeInOutExpo'
    });

    setInterval(function () {
        $('.stats-section-stat.out, .out[data-inview-check]').each(function () {
            if ($(this).atdInview()) {
                $(this).addClass('inview').removeClass('out');

                $(this).find('[data-percent]').each(function () {
                    var percent = $(this).attr('data-percent');
                    $(this).width(percent + '%');
                });

                $(this).find('[data-vertical-percent]').each(function () {
                    var percent = $(this).attr('data-vertical-percent');
                    $(this).height(percent + '%');
                });
            }
        });
    }, 100);

    // $.fn.atdInview = function (partial) {
    //     var $t = $(this),
    //         $w = $(window),
    //         viewTop = $w.scrollTop(),
    //         viewBottom = viewTop + $w.height(),
    //         _top = $t.offset().top,
    //         _bottom = _top + $t.height(),
    //         compareTop = partial === true ? _bottom : _top,
    //         compareBottom = partial === true ? _top : _bottom;

    //     return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    // };

    /* Modal Event listeners */
    $('[data-toggle="modal"]').click(function (e) {
        e.preventDefault();

        var target = $($(this).attr('href'));

        target.toggleClass('on');

        $('body').addClass('noscroll');

        if ($('.validate-form').length) {
            $('.validate-form').validate();
        }

        if (!target.hasClass('on') && target.find('[data-vimeo-player]').length) {
            target.find('[data-vimeo-player]').attr('src', '');
        }

        if ($('[data-youtube]').length) {
            $('[data-youtube]').each(function () {
                $(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            });
        }

        if (target.find($('[id^="vidyard_"]')).length !== 0) {
            var vidSrc = target.find($('.vidyard_iframe')).attr('src').replace('.js', '.html');
            if ($($(e.target)[0]).attr('class') === 'close' || $($(e.target)[0]).attr('class') === 'modal-overlay') {
                target.find($('.vidyard_iframe')).attr('src', vidSrc);
            } else {

            }
        }
    });

    $('[data-modal-next]').click(function (e) {
        e.preventDefault();
        var modal = $(this).closest('[data-group]');
        var group = $('[data-group="' + modal.attr('data-group') + '"]');
        var index;
        var next;

        group.each(function () {
            if (modal.attr('id') == $(this).attr('id')) {
                index = $(this).index();
            }
        });

        if (index >= (group.length - 1)) {
            next = $(group[0]);
        } else {
            next = $(group[index + 1]);
        }

        modal.addClass('no-transition');
        next.addClass('no-transition');

        modal.removeClass('on');
        next.addClass('on');
    });

    $('[data-modal-prev]').click(function (e) {
        e.preventDefault();
        var modal = $(this).closest('[data-group]');
        var group = $('[data-group="' + modal.attr('data-group') + '"]');
        var index;
        var next;

        group.each(function () {
            if (modal.attr('id') == $(this).attr('id')) {
                index = $(this).index();
            }
        });

        if (index - 1 < 0) {
            next = $(group[group.length - 1]);
        } else {
            next = $(group[index - 1]);
        }

        modal.addClass('no-transition');
        next.addClass('no-transition');

        modal.removeClass('on');
        next.addClass('on');
    });

    $('[data-toggle="gallery-modal"]').click(function (e) {
        e.preventDefault();

        var target = $('#gallery-modal'),
            title = $(this).data('title'),
            favs = $(this).data('favs'),
            source = $(this).data('image'),
            state = $(this).data('state') === 'active',
            img = target.find('.gallery-image img');

        img.on('load', function () {
            $(this).css({ 'visibility': 'visible' });
        });

        target.find('.image-title').html(title);
        target.find('.fav-count').html(favs);
        img.attr('src', source).css({ 'visibility': 'hidden' });
        if (state) {
            target.find('.fav-container').addClass('active');
        } else {
            target.find('.fav-container').removeClass('active');
        }

        target.find('.fav-container').attr('data-id', $(this).next().attr('data-id'));

        target.toggleClass('on');
    });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            $('[data-modal]').removeClass('on no-transition');
        }
    });

    $('[data-close="modal"], .modal .close').click(function (e) {
        e.preventDefault();
        $('.modal-container').removeClass('on no-transition');
        $('body').removeClass('noscroll');
    });

    /* auto open modals based on url hash */
    $('[data-auto-modal]').each(function () {
        if (window.location.hash === $(this).data('auto-modal')) {
            $(this).addClass('on');
            $('body').addClass('noscroll');
        }
    });

    /* warranty advantage / fni faq section */
    $('.fni-faq-q').click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    //Why Autotrader:
    $('[data-animate-scroll]').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        var offset = target.offset().top;

        $('html, body').animate({
            scrollTop: (offset) + 'px'
        }, 1000, 'swing');
    });

    $('#fixed-nav').onePageNav({

        currentClass: 'current',
        scrollSpeed: 1000,
        easing: 'swing'
    });

    if ($('[data-atctab]').length) {
        $('[data-atctab]').click(function (e) {
            e.preventDefault();
            var target = $($(this).attr('href'));

            $('[data-atctab], .all-the-cars-tab').removeClass('active');
            $(this).addClass('active');
            target.addClass('active');
        });
    }

    if ($('.all-the-cars-prev').length) {
        $('.all-the-cars-prev').click(function (e) {
            e.preventDefault();
            var target = $('[data-atctab].active').prev();

            if (!target.length) {
                target = $('[data-atctab]').last();
            }

            target.trigger('click');
        });
    }

    if ($('.all-the-cars-next').length) {
        $('.all-the-cars-next').click(function (e) {
            e.preventDefault();
            var target = $('[data-atctab].active').next();

            if (!target.length) {
                target = $('[data-atctab]').first();
            }

            target.trigger('click');
        });
    }

    setInterval(function () {
        $('.stats-section-stat.out').each(function () {
            if ($(this).atdInview()) {
                $(this).addClass('inview').removeClass('out');

                $(this).find('[data-percent]').each(function () {
                    var percent = $(this).attr('data-percent');
                    $(this).width(percent + '%');
                });

                $(this).find('[data-vertical-percent]').each(function () {
                    var percent = $(this).attr('data-vertical-percent');
                    $(this).height(percent + '%');
                });
            }
        });

        $('.goto-slidein.out').each(function () {
            if ($(this).atdInview(false, true)) {
                $(this).addClass('inview').removeClass('out');
            }
        });
    }, 100);

    $.fn.atdInview = function (partial, half) {
        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = half === true ? _top + ($t.height() / 2) : _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

    /* Slideshow setup */
    $(function () {
        if ($('[atd-slideshow]').length > 0) {
            $('[atd-slideshow]').slideshow({
                controls: {
                    enabled: true,
                    prevLabel: "&lsaquo;",
                    nextLabel: "&rsaquo;"
                },
                theme: 'my-theme',
                autofit: true
            });
        }

        if ($('[specialty-slideshow]').length > 0) {
            $('[specialty-slideshow]').slideshow({
                controls: {
                    enabled: true,
                    prevLabel: "&lsaquo;",
                    nextLabel: "&rsaquo;"
                },
                theme: 'specialty-slideshow',
                autofit: true
            });

        }

        if ($('[cxl-slideshow]').length > 0) {
            $('[cxl-slideshow]').slideshow({
                controls: {
                    enabled: true,
                    prevLabel: "&lsaquo;",
                    nextLabel: "&rsaquo;"
                },
                theme: 'cxl-slideshow',
                autofit: true,
                autoplay: 5000
            });
        }

        if ($('[atd-slideshow-hero]').length > 0) {
            $('[atd-slideshow-hero]').slideshow({
                autoplay: 5000,
                swipe: true,
                random: true,
                initialSlide: 0,
                controls: {
                    enabled: false
                },
                theme: 'my-theme',
                autofit: true
            });
        }
    });

    /* == Add Google Analytics data attributes for links in the top header, main nav, and footer nav ==*/
    var allHeaderLinks = $('.top-bar-menu .text-link'),
        allMainNavLinks = $('.menu.main li a'),
        allFooterLinks = $('footer .menu li a');

    var internalUrl = window.location.hostname;

    var headerSectionText = " from Site Header",
        mainNavSectionText = " from Site Nav",
        footerSectionText = " from Site Footer Nav";

    addAnalyticAttributes(allHeaderLinks, internalUrl, headerSectionText);
    addAnalyticAttributes(allMainNavLinks, internalUrl, mainNavSectionText);
    addAnalyticAttributes(allFooterLinks, internalUrl, footerSectionText);

    /** @function addAnalyticAttributes
     *   @param {object | jQuery selector string} elements - A nodelist of elements (usually provided by jQuery)
     *   @param {string} stringToMatch - The string that you are looking to find in the href
     *   @param {string} sectionString - an optional string to append to the end of the data section
     *   @returns { Bool} - Returns false if an error is passed to the catch block, true if try executes all the way
     *   @description Given a nodelist of dom elements, this function will add specific attributes to liks that will later be pushed to Google Analytics.
     */
    function addAnalyticAttributes(elements, stringToMatch, sectionString) {
        try {
            if (typeof elements === 'undefined') {
                throw "string to match is undefined";//throw if parameter not supplied
            }
            if (typeof stringToMatch === 'undefined') {
                throw "string to match is undefined";//throw if parameter not supplied
            }
            sectionString = (typeof sectionString !== 'undefined') ? sectionString : ""; //manually set default parameter values

            for (var i = 0; i < elements.length; i++) {
                var linkText = $(elements[i]).text().trim();

                if (!$(elements[i]).attr('data-label')) {
                    $(elements[i]).attr("data-label", linkText + sectionString);
                }

                if (!$(elements[i]).attr('data-category')) {
                    $(elements[i]).attr("data-category", "link");//Add "link" content to data-category attribute
                }

                if (!$(elements[i]).attr('data-action')) {
                    $(elements[i]).attr("data-action", "click");//Add "click" content to data-action attribute
                }
            }
            return true;
        } catch (err) {
            //console.warn('The addAnalyticAttributes error: ' + err);
            return false;
        }
    }//End fn declaration

    $('body').addClass('page-loaded');

    $('.faq-accordion-q').click(function (e) {
        e.preventDefault();
        var target = $(this).siblings('.faq-accordion-a');
        $('.faq-accordion-q').not(this).removeClass('open');
        $(this).toggleClass('open');
        $('.faq-accordion-a').not(target).slideUp(400);
        target.slideToggle(400);
    })

    $(document).on('click', function (e) {
        if (!$(e.target).hasClass('click-trigger') && !$(e.target).parents('.click-trigger').length) {
            $('.click-trigger.active').removeClass('active');
        }
    });

    $('.menu .click-trigger > a').click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    /* Animations for Dealer Influence */

    /* People */
    $('[data-greensock-inview="animation-1"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            var $person_1 = $('#person-1');
            var $person_2 = $('#person-2');
            var $person_3 = $('#person-3');
            var $person_4 = $('#person-4');
            var $person_5 = $('#person-5');
            var $person_6 = $('#person-6');
            var $person_7 = $('#person-7');
            var $person_8 = $('#person-8');
            var $person_9 = $('#person-9');
            var $person_10 = $('#person-10');
            var $person_11 = $('#person-11');
            var $person_12 = $('#person-12');
            var $person_13 = $('#person-13');
            var $person_14 = $('#person-14');
            var $stat_1 = $('#stat-1');
            var $stat_2 = $('#stat-2');
            var $stat_3 = $('#stat-3');
            var $inblue_1 = $('#InBlue-1');
            var $inblue_2 = $('#InBlue-2');
            var $inblue_3 = $('#InBlue-3');
            var $outblue_1 = $('#OutBlue-1');
            var $outblue_2 = $('#OutBlue-2');
            var $outblue_3 = $('#OutBlue-3');
            var $orange = $('#Orange');

            TweenMax.set($person_1, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_2, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_3, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_4, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_5, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_6, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_7, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_8, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_9, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_10, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_11, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_12, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_13, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($person_14, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($stat_1, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($stat_2, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($stat_3, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($outblue_1, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($outblue_2, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($outblue_3, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($inblue_1, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($inblue_2, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($inblue_3, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($orange, {
                opacity: 0,
                drawSVG: '0%',
            })

            var tl_process = new TimelineMax({
                // Options
            });

            tl_process.to($person_1, .5, {
                opacity: 1,
                drawSVG: '100%',
            })
                .to($person_2, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_3, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_4, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_5, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($inblue_1, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($outblue_1, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($stat_1, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_6, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.25")
                .to($person_7, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_8, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_9, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_10, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($inblue_2, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($outblue_2, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($stat_2, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_11, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.25")
                .to($person_12, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_13, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($person_14, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($inblue_3, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($outblue_3, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
                .to($orange, .25, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.5")
                .to($stat_3, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.4")
        }
    });


    var count = parseInt($('#panel').data("count"));

    /* Road */
    // $('.panel-control').on("click", function(e) {
    //     e.preventDefault();
    //     if(count === 5) {
    //         count = 1;
    //     } else if(count) {
    //         count++;

    //         console.log(count);
    //     }

    //     $('.panel').attr("data-count", count);

    //     console.log('panel clicked');
    // });
    $('.roadmap-wrap').on("click", function (e) {
        e.preventDefault();
        if (count === 5) {
            count = 1;
        } else if (count) {
            count++;

            // console.log(count);
        }

        $('.panel').attr("data-count", count);

        // console.log('panel clicked');
    });
    $('[data-greensock-inview="animation-2"]').on('inview', function (event, isInView) {
        if (isInView) {
            var $road_path = $('#road-path');
            var $road_lines = $('#road-lines');
            var $icon_stars = $('#icon-stars');
            var $icon_star = $('.icon-star');
            var $icon_balance = $('#icon-balance');
            var $icon_click = $('#icon-click');
            var $icon_click_pointer = $('#icon-click-pointer');
            var $icon_click_line = $('.icon-click-line');
            var $icon_dollar = $('#icon-dollar');
            var $icon_flag = $('#icon-flag');
            var $icon_flag_flag = $('#icon-flag-flag');
            var $arrow_1 = $('.arrow_1');
            var $arrow_2 = $('.arrow_2');
            var $arrow_3 = $('.arrow_3');
            TweenMax.set($road_path, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($road_lines, {
                opacity: 0,
                drawSVG: '0%',
            })
            TweenMax.set($icon_stars, {
                opacity: 0,
            })
            TweenMax.set($icon_balance, {
                opacity: 0,
                transformOrigin: 'center bottom'
            })
            TweenMax.set($icon_click, {
                opacity: 0,
            })
            TweenMax.set($icon_click_line, {
                opacity: 0,
                scale: 0,
                transformOrigin: "center"
            })
            TweenMax.set($icon_dollar, {
                opacity: 0,
            })
            TweenMax.set($icon_flag, {
                opacity: 0,
            })
            TweenMax.set($arrow_1, {
                opacity: .0,
            })
            TweenMax.set($arrow_2, {
                opacity: .0,
            })
            TweenMax.set($arrow_3, {
                opacity: .0,
            })
            var tl_road = new TimelineMax({
                // Options
            });
            tl_road.to($road_path, .5, {
                opacity: 1,
                drawSVG: '100%',
            })
                .to($road_lines, .5, {
                    opacity: 1,
                    drawSVG: '100%',
                }, "=-.25")
                .to($arrow_1, .5, {
                    opacity: .7,
                }, "=-.3")
                .to($arrow_2, .5, {
                    opacity: .7,
                }, "=-.3")
                .to($arrow_3, .5, {
                    opacity: .7,
                }, "=-.3")
                .to($arrow_1, .5, {
                    opacity: 1,
                    repeat: -1,
                    repeatDelay: 0.5,
                }, "=-.3")
                .to($arrow_2, .5, {
                    opacity: 1,
                    repeat: -1,
                    repeatDelay: 0.5,
                }, "=-.3")
                .to($arrow_3, .5, {
                    opacity: 1,
                    repeat: -1,
                    repeatDelay: 0.5,
                }, "=-.3")
                .to($icon_stars, .4, {
                    opacity: 1,
                }, "=-1.7")
                .to($icon_balance, .4, {
                    opacity: 1,
                }, "=-.3")
                .to($icon_click, .4, {
                    opacity: 1,
                }, "=-.3")
                .to($icon_dollar, .4, {
                    opacity: 1,
                }, "=-.3")
                .to($icon_flag, .4, {
                    opacity: 1,
                }, "=-.3")
                .staggerTo($icon_star, .3, {
                    opacity: .7,
                    repeat: -1,
                    repeatDelay: 0.1,
                }, .1)
                .to($icon_balance, 2, {
                    rotation: -40,
                }, 1)
                .to($icon_balance, 2, {
                    rotation: -5,
                    repeat: -1,
                    yoyo: true,
                    ease: Back.easeInOut,
                }, 1)
                .to($icon_flag_flag, 1.5, {
                    skewY: 10,
                    repeat: -1,
                    yoyo: true,
                    ease: Sine.easeInOut,
                    skewType: "simple"
                }, 1)
                .fromTo($icon_click_pointer, 0.5, {
                    scale: 0.9,
                    repeat: -1,
                    repeatDelay: 3,
                    ease: Back.easeInOut
                }, {
                    scale: 1,
                    repeat: -1,
                    repeatDelay: 3,
                    ease: Back.easeInOut
                }, 1)
                .fromTo($icon_click_line, .5, {
                    opacity: 1,
                    repeat: -1,
                    repeatDelay: 3,
                    scale: 1.5,
                }, {
                    opacity: 0,
                    repeat: -1,
                    repeatDelay: 3,
                    scale: 0,
                }, 1)
                .to($icon_dollar, 3, {
                    y: "-=3",
                    yoyo: true,
                    repeat: -1,
                    repeatDelay: 0,
                    ease: Back.easeInOut
                }, 1)
        }
    });

    /* Timeline */
    // $('[data-greensock-inview="animation-3"]').on('inview', function (event, isInView) {
    //     $(this).unbind('inview');

    //     if (isInView) {
    //         var $timeline_icon = $('.timeline-icon');
    //         var $timeline_bar = $('.timeline-bar-wrap');

    //         TweenMax.set($timeline_bar, {
    //         transformOrigin: "0% 50%",
    //         scaleX: '0',
    //         })
    //         TweenMax.set($timeline_icon, {
    //         xPercent: -300,
    //         opacity: 0,
    //         scaleX: 0
    //         })

    //         var tl_timeline = new TimelineMax();

    //         tl_timeline.staggerTo($timeline_bar, 1, {
    //         scaleX: 1,
    //         }, .5)
    //         .staggerTo($timeline_icon, .75, {
    //         xPercent: 0,
    //         opacity: 1,
    //         transformOrigin: "50% 50%",
    //         scaleX: 1
    //         }, .5, .3)    
    //     }
    // });

    /* 3 Circles */
    $('[data-greensock-inview="pie-chart-1"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-1').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });
    $('[data-greensock-inview="pie-chart-2"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-2').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });
    $('[data-greensock-inview="pie-chart-3"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-3').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });
    $('[data-greensock-inview="pie-chart-4"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-4').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });
    $('[data-greensock-inview="pie-chart-5"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-5').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });

    $('[data-greensock-inview="pie-chart-6"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            $('.pie-chart-6').each(function (index, element) {
                var num = +($(this).text());
                var chart = '<svg viewBox="0 0 32 32"><circle class="circle" r="16" cx="16" cy="16" style="stroke-dasharray: 10 100" /><circle class="" r="14" cx="16" cy="16" style="fill: #042265;" /></svg>';
                $(this).html(chart);
                $(this).find('.circle').css('stroke-dasharray', num + ' 100');
                $(this).append('<h4>' + num + '%</h4>');
            });
        }
    });

    /* Circle-Influences */
    $('[data-greensock-inview="animation-5"]').on('inview', function (event, isInView) {
        if (isInView) {


        }
    });

    /* Circle-Journey */
    $('[data-greensock-inview="animation-6"]').on('inview', function (event, isInView) {
        if (isInView) {


        }
    });

    /* Horizontal Bars */
    $('[data-greensock-inview="animation-7"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            var $bar = $('.bar-seg');
            var $bar_num = $('.bar span');

            TweenMax.set($bar, {
                transformOrigin: "0% 50%",
                scaleX: '0'
            });
            TweenMax.set($bar_num, {
                opacity: '0'
            })

            var tl_bar = new TimelineMax({
            })

            tl_bar.staggerTo($bar, .4, {
                scaleX: '1',
                ease: Power0.easeNone,
            }, .3)
                .staggerTo($bar_num, .4, {
                    opacity: '1'
                }, .3, .4)
        }
    });

    /* Vertical Bars */
    $('[data-greensock-inview="animation-8"]').on('inview', function (event, isInView) {
        if (isInView) {
            $(this).unbind('inview');

            var $first = $('.first');
            var $last = $('.last');

            TweenMax.set($first, {
                transformOrigin: 'center bottom',
                scale: '0',
                opacity: '0',
                borderRadius: '50% 50% 0 0'
            })

            var tl_first = new TimelineMax({
            })

            tl_first.staggerTo($first, .3, {
                scale: '1',
                opacity: '1',
                ease: Power0.easeOut,
                borderRadius: '0% 0% 0% 0%'
            }, -.2);

            TweenMax.set($last, {
                transformOrigin: 'center bottom',
                scale: '0',
                opacity: '0',
                borderRadius: '50% 50% 0 0'
            })

            var tl_last = new TimelineMax({
            })

            tl_last.staggerTo($last, .3, {
                scale: '1',
                opacity: '1',
                ease: Power0.easeOut,
                borderRadius: '0% 0% 0% 0%'
            }, -.2);
        }
    });

    $(window).scroll(function () {
        $('.explore').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 300) {
                $(this).addClass("fadeIn");
            }
        });
    });

    $(window).scroll(function () {
        $('.consider').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 550) {
                $(this).addClass("fadeIn");
            }
        });
    });


    $(window).scroll(function () {
        $('.select').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 600) {
                $(this).addClass("fadeIn");
            }
        });
    });

    $(window).scroll(function () {
        $('.buy').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 500);
        }
        );
    });

    $(window).scroll(function () {
        $('.own').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 600) {
                $(this).addClass("fadeIn");
            }
        });
    });

    $('[data-slick]').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    /* fill out salesforce product field on contact form */
    var contactForm = $('#contact-form');
    var productField = $('#00N0L000006bRP9');
    if (contactForm.length && productField.length) {
        if (productField.is(':checked')) {
            contactForm.append('<input type="hidden" id="product-of-interest-1" name="Product of Interest 1" value="DMKT: Digital Retailing (except FinanceDriver)" />');
        }

        productField.on('change', function () {
            if (productField.is(':checked') && $('#product-of-interest-1').length === 0) {
                contactForm.append('<input type="hidden" id="product-of-interest-1" name="Product of Interest 1" value="DMKT: Digital Retailing (except FinanceDriver)" />');
            }
            if (!productField.is(':checked') && $('#product-of-interest-1').length) {
                $('#product-of-interest-1').remove();
            }
        });
    }

});//End jQuery.ready wrapper
